import WRAP from 'WRAP-JS'
import { configInformationZoneDh, configInformationZoneLayer } from './config/ConfigInformationZone';
import { MAP_ID_INFORMATION_ZONE } from "../../../store/MapContentsState";
import { COMMUNICATE_ERROR_MESSAGE_INFORMATION, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from '../../../constants/ErrorMessage';

class InformationZone {
  static NAME = MAP_ID_INFORMATION_ZONE
  dh;
  layer;
  ready = false;
  contentsDispatcher;
  errorMessageInfo;

  constructor() {
    this.layer = new WRAP.Geo.Layer(this.constructor.NAME);
    this.layer.setVisible(false);
    this.layer.setTooltip(this._toolTip);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  async initData() {
    return new Promise(resolve => {
      this.dh = new WRAP.Data(configInformationZoneDh);
      this.dh.load('data', null, false, ref => {
        if (this.errorMessageInfo) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo});
          this.errorMessageInfo = null;
        }
        resolve(ref);
      }, _ => {
        this.errorMessageInfo = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_INFORMATION,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
    });
  }

  initLayer() {
    this.layer.configure(this.dh, configInformationZoneLayer);
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this.layer;
  }

  getLegend() {
    return {
      id: InformationZone.NAME,
      label: 'Information zone'
    }
  }

  setVisible(visible) {
    if (!this.ready) return;

    if (this.layer.visible() === visible) {
      return;
    }

    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  changeRoutePointEditing(routePointEditing) {
    this.layer.disableInteraction(routePointEditing);
  }

  _toolTip(geo) {
    const prop = geo.properties;
    const tooltip = [`<ul><li>${prop.name}</li><li>${prop.height}</li></ul>`];
    tooltip.push(`<hr/><ul>`);
    ['RDO', 'REMOTE', 'RAG', 'airport_info']
      .map(key => prop[key])
      .filter(val => val !== null)
      .forEach(val => tooltip.push(`<li>${val}</li>`));
    tooltip.push(`</ul>`);
    return tooltip.join('');
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default InformationZone;
